import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../config/api';

// ⚙️ Base del backend
const API_URL = API_BASE_URL;
const HOST = process.env.REACT_APP_HOST || API_URL;

// Helper para normalizar la URL de la foto
const resolvePhotoUrl = (raw) => {
  if (!raw) return '';

  const v = String(raw).trim();
  if (!v) return '';

  // Absoluta → la dejamos tal cual
  if (/^https?:\/\//i.test(v)) return v;

  // Empieza con / → la colgamos del backend
  if (v.startsWith('/')) return `${HOST}${v}`;

  // Caso raro: sin / inicial
  return `${HOST}/${v}`;
};

const AthleteProfile = ({ isTrainerView = false, athleteId = null }) => {
  const userId = isTrainerView ? athleteId : localStorage.getItem('userId');

  console.log(
    '🧠 AthleteProfile recibido → athleteId:',
    athleteId,
    '| isTrainerView:',
    isTrainerView
  );

  const [profileData, setProfileData] = useState({
    name: '',
    profilePicture: '',
  });

  useEffect(() => {
    const fetchProfileData = async () => {
      if (!userId) {
        console.error('❌ No se encontró el userId');
        return;
      }

      try {
        const response = await axios.get(
          `${API_URL}/api/athletes/profile/${userId}`
        );
        const athlete = response.data.athlete;

        const name = `${athlete.firstName || ''} ${athlete.lastName || ''}`.trim();

        // Ruta cruda que viene del backend (o default)
        const rawPhoto =
          athlete?.profilePhoto || '/uploads/athletes/default.jpg';

        // Normalizamos + bust de caché
        const baseUrl = resolvePhotoUrl(rawPhoto);
        const profilePicture = `${baseUrl}${
          baseUrl.includes('?') ? '&' : '?'
        }t=${Date.now()}`;

        setProfileData({ name, profilePicture });
      } catch (error) {
        console.error('❌ Error al cargar el perfil del atleta:', error);
        const fallback = resolvePhotoUrl('/uploads/athletes/default.jpg');
        setProfileData({
          name: 'No disponible',
          profilePicture: fallback,
        });
      }
    };

    fetchProfileData();
  }, [userId, athleteId, isTrainerView]);

  const fallbackDefault = resolvePhotoUrl('/uploads/athletes/default.jpg');

  return (
    <header className="dashboard-header">
      <div className="dashboard-header-left">
        <img
          className="profile-photo"
          src={profileData.profilePicture || fallbackDefault}
          alt="Foto de perfil"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = fallbackDefault;
          }}
        />
        <h5 className="dashboard-name">
          {profileData.name || 'Nombre no disponible'}
        </h5>
      </div>
    </header>
  );
};

export default AthleteProfile;
